import * as React from 'react';
// import {
//   ContentBox,
//   ContentBoxHeader,
//   ContentBoxParagraph,
// } from '../demo/ContentBox';
// import {LabeledInput, InputRow} from '../demo/LabeledInput';
import {CellMeasurer, CellMeasurerCache} from 'react-virtualized/dist/es/CellMeasurer';
import AutoSizer from 'react-virtualized/dist/es/AutoSizer';
import WindowScroller from 'react-virtualized/dist/es/WindowScroller';
import createCellPositioner from 'react-virtualized/dist/es/Masonry/createCellPositioner';
import Masonry from 'react-virtualized/dist/es/Masonry';
import InfiniteScroll from 'react-infinite-scroller';
import { Link } from 'react-router-dom';

export default class GridExample extends React.PureComponent {
//   static contextTypes = {
//     list: PropTypes.instanceOf(Immutable.List).isRequired,
//   };

  constructor(props) {
    super(props);

    this._columnCount = props.columnCount || 0;

    this._cache = new CellMeasurerCache({
      defaultHeight: 250,
      defaultWidth: 200,
      fixedWidth: true,
    });

    this.state = {
      columnWidth: this.props.column || 200,
      height: 300,
      gutterSize: this.props.gutter || 16,
      overscanByPixels: 1000,
      windowScrollerEnabled: true,
    };

    this._cellRenderer = this._cellRenderer.bind(this);
    this._onResize = this._onResize.bind(this);
    this._renderAutoSizer = this._renderAutoSizer.bind(this);
    this._renderMasonry = this._renderMasonry.bind(this);
    this._setMasonryRef = this._setMasonryRef.bind(this);
  }

  render() {
    console.log('rendered')
    const {
      columnWidth,
      height,
      gutterSize,
      overscanByPixels,
      windowScrollerEnabled,
    } = this.state;

    let child;

    if (windowScrollerEnabled) {
      child = (
        <WindowScroller overscanByPixels={overscanByPixels} scrollingResetTimeInterval={50}>
          {this._renderAutoSizer}
        </WindowScroller>
      );
    } else {
      child = this._renderAutoSizer({height});
    }

    return (
      <div>
        {child}
        {!this.props.hasMore ?
         <div style={{padding: "30px 0", fontSize: '14px',color: '#818181', textAlign: 'center'}}>No More</div>
        :
        <div style={{padding: "30px 0", fontSize: '14px',color: '#818181', textAlign: 'center'}}>Loading ...</div>
        }

      </div>
    );
  }

  _calculateColumnCount() {
    const {columnWidth, gutterSize} = this.state;
    this._columnCount = Math.floor((this._width+gutterSize) / (columnWidth + gutterSize));
  }

  _cellRenderer({index, key, parent, style}) {
    // const {list} = this.context;
    const {list, cellContent} = this.props;
    const {columnWidth} = this.state;

    const datum = list[index];
    return (
      <CellMeasurer cache={this._cache} index={index} key={key} parent={parent}>
        <div
          style={{
            ...style,
            width: columnWidth
          }}>
          {cellContent(columnWidth, datum)}
        </div>
      </CellMeasurer>
    );
  }

  _initCellPositioner() {
    if (typeof this._cellPositioner === 'undefined') {
      const {columnWidth, gutterSize} = this.state;

      this._cellPositioner = createCellPositioner({
        cellMeasurerCache: this._cache,
        columnCount: this._columnCount,
        columnWidth,
        spacer: gutterSize,
      });
    }
  }

  _onResize({width}) {
    this._width = width;

    this._calculateColumnCount();
    this._resetCellPositioner();
    this._masonry.recomputeCellPositions();
  }

  _renderAutoSizer({height, scrollTop}) {
    this._height = height;
    this._scrollTop = scrollTop;

    const {overscanByPixels} = this.state;

    return (
      <AutoSizer
        disableHeight
        height={height}
        onResize={this._onResize}
        overscanByPixels={overscanByPixels}
        scrollTop={this._scrollTop}>
        {this._renderMasonry}
      </AutoSizer>
    );
  }

  _renderMasonry({width}) {
    this._width = width;
    console.log('render masonry')
    this._calculateColumnCount();
    this._initCellPositioner();

    const {height, overscanByPixels, windowScrollerEnabled} = this.state;
    const {list} = this.props;
    return (
      <InfiniteScroll
        pageStart={0}
        loadMore={this.props.loadFunc}
        hasMore={this.props.hasMore}
        threshold={800}
      >
      <Masonry
        autoHeight={windowScrollerEnabled}
        cellCount={list.length}
        cellMeasurerCache={this._cache}
        cellPositioner={this._cellPositioner}
        cellRenderer={this._cellRenderer}
        // height={windowScrollerEnabled ? this._height : height}
        height={this._height}
        overscanByPixels={overscanByPixels}
        ref={this._setMasonryRef}
        scrollTop={this._scrollTop}
        width={width}
        tabIndex={false}
        overscanByPixels={100}
      />
        
      </InfiniteScroll>
    );
  }

  // This is a bit of a hack to simulate newly loaded cells
  _resetList = () => {
    const ROW_HEIGHTS = [25, 50, 75, 100];

    // const {list} = this.context;
    const {list} = this.props;
    // list.forEach(datum => {
    //   datum.size = ROW_HEIGHTS[Math.floor(Math.random() * ROW_HEIGHTS.length)];
    // });

    this._cache.clearAll();
    this._resetCellPositioner();
    this._masonry.clearCellPositions();
  };

  _resetCellPositioner() {
    const {columnWidth, gutterSize} = this.state;

    this._cellPositioner.reset({
      columnCount: this._columnCount,
      columnWidth,
      spacer: gutterSize,
    });
  }

  _setMasonryRef(ref) {
    this._masonry = ref;
  }
}


// WEBPACK FOOTER //
// ./src/features/homepage/feed/component/streetGallery.js